import { a as y, c as l } from "./createOperation-Opo4US4u.js";
import { M as h, e as v, f as P, g as I, h as F, j as C, i as L, k as S, a6 as A, a4 as B, a2 as U, a7 as W, a1 as E, a5 as x, a3 as T, m as w, l as O, n as _, V as N, o as R, p as k, q as H, r as m, u as z, s as D, t as V, v as j, w as G, x as J, D as K, F as X, H as Y, J as Z, y as $, X as q, A as b, z as aa, B as ea, C as ta, E as sa, G as oa, I as ia, W as na, K as ra, Z as ua, Y as ya, _ as la, L as ca, N as pa, O as da, P as fa, $ as Qa, a0 as ga, Q as Ma, R as ha, S as va, T as Pa, U as Ia } from "./sportEventQuery-BBIGFkSz.js";
import { p as Ca } from "./personQuery-DbzfgL5T.js";
import { M as Sa, b as Aa, a as Ba, d as Ua, e as Wa, f as Ea, h as xa, m as Ta, g as wa, n as Oa, i as _a, r as Na, s as Ra, j as ka, k as Ha, u as ma, v as za } from "./viewOptionQuery-CA9LgZQl.js";
import { n as Va } from "./notificationSubmitFeedback-_YcWy0Xu.js";
const c = y(({ member: a, authorizedPuids: i }) => {
  var o, t, s;
  return {
    isAuthorized: !!(a != null && a.id.puid && i.has(a.id.puid)),
    puid: (a == null ? void 0 : a.id.puid) ?? null,
    ottId: (a == null ? void 0 : a.id.ottId) ?? null,
    displayName: (a == null ? void 0 : a.displayName) ?? null,
    isAdmin: !!((o = a == null ? void 0 : a.family) != null && o.familyAdmin),
    avatarsUrl: ((t = a == null ? void 0 : a.avatar) == null ? void 0 : t.avatarsUrl) ?? null,
    hasSubscription: !!((s = a == null ? void 0 : a.subscriptionInfo) != null && s.hasSubscription),
    passportEmail: (a == null ? void 0 : a.__typename) === "UserProfile" ? a.passportEmail : "",
    passportLogin: (a == null ? void 0 : a.__typename) === "UserProfile" ? a.passportLogin : ""
  };
}), p = y(({ familyData: a }) => {
  var t, s, n, r, u;
  const i = new Set(
    (s = (t = a.yandex) == null ? void 0 : t.multiAccounts) == null ? void 0 : s.accounts.map((e) => e.puid)
  ), o = (n = a.family) != null && n.members ? a.family.members.filter((e) => e == null ? void 0 : e.id.puid).map((e) => c({ member: e, authorizedPuids: i })) : [];
  return {
    canInviteUser: !!((r = a.family) != null && r.canInviteUser),
    familyAdmin: !!((u = a.family) != null && u.familyAdmin),
    members: o
  };
}), d = {
  name: "Family",
  body: "query Family { userProfile { ...FamilyFragment } } fragment FamilyFragment on UserProfileInterface { family { canInviteUser familyAdmin members(filter: {types: [USER_PROFILE]}) { ...FamilyMember } } ...MultiAccountsFragment } fragment FamilyMember on UserProfileInterface { __typename id { puid ottId } displayName avatar { avatarsUrl } subscriptionInfo { hasSubscription } ... on UserProfile { passportLogin passportEmail } family { familyAdmin } } fragment MultiAccountsFragment on UserProfileInterface { yandex { multiAccounts { accounts( filter: {includeCurrentAccount: false, includeCurrentFamilyMembers: true} ) { puid } } } }",
  get variables() {
  },
  get query() {
  }
}, Q = l(d, {
  resolve: (a) => ({
    familyData: (a == null ? void 0 : a.userProfile) ?? null
  }),
  hydrate: (a) => a.familyData ? p({
    familyData: a.familyData
  }) : null
});
export {
  Sa as MovieNotFoundError,
  h as MutationError,
  v as addToSearchHistoryMutation,
  P as assignDcbSubscriptionMutation,
  Aa as bootstrapQuery,
  I as channelCategoryListQuery,
  F as channelListQuery,
  C as channelProgramInfoQuery,
  L as channelQuery,
  Ba as compositeOffersQuery,
  S as continueWatchingQuery,
  A as createLegacyClipPlayerBaseInfo,
  B as createLegacyEpisodePlayerBaseInfo,
  U as createLegacyFilmPlayerBaseInfo,
  W as createLegacyOttTrailerPlayerBaseInfo,
  E as createLegacyPlayerBaseInfoContent,
  x as createLegacyTvChannelPlayerBaseInfo,
  T as createLegacyVideoPlayerBaseInfo,
  Ua as createUserProfileMutation,
  Wa as experimentsQuery,
  Q as familyAccountsQuery,
  Ea as favoritesQuery,
  xa as historyQuery,
  Ta as mineQuery,
  w as movieCardContentActionsQuery,
  O as movieCardQuery,
  _ as movieDirectorsFilmographyQuery,
  N as moviePlannedToWatchQuery,
  R as moviePromoContentActionsQuery,
  wa as movieQuery,
  k as movieSimilarQuery,
  H as movieWebPageQuery,
  Oa as notificationMarkViewedMutation,
  Va as notificationSubmitFeedbackMutation,
  _a as notificationsByConsumerQuery,
  Ca as personQuery,
  m as personSeoMetaQuery,
  z as playerBaseInfoQuery,
  D as playerMetaQuery,
  V as playerStreamMetaQuery,
  j as purchasesQuery,
  Na as remoteConfigQuery,
  G as removeContinueWatchingItemMutation,
  J as removeFromSearchHistoryMutation,
  K as removeMovieEmotionMutation,
  X as removeMovieNotInterestedMutation,
  Y as removeMoviePlannedToWatchMutation,
  Z as removeMovieWatchedMutation,
  $ as removePlannedToWatchMutation,
  q as saveLastWatchedChannel,
  b as seasonWithEpisodesQuery,
  aa as seasonsMetadataQuery,
  ea as selectionQuery,
  ta as setMovieEmotionMutation,
  sa as setMovieNotInterestedMutation,
  oa as setMoviePlannedToWatchMutation,
  ia as setMovieWatchedMutation,
  Ra as setPlannedToWatchMutation,
  na as setWatchParamsMutation,
  ra as showcaseQuery,
  ua as sportEventQuery,
  ya as sportShowcaseQuery,
  la as subscriptionInfoQuery,
  ka as subscriptionPurchaseOptionsListQuery,
  Ha as subscriptionPurchaseOptionsQuery,
  ca as suggestEmptyPrefixQuery,
  pa as suggestSearchQuery,
  da as suggestSelectionQuery,
  fa as timingsUserCredentialsQuery,
  Qa as updatePreferredWatchingLanguageMutation,
  ma as userProfileQuery,
  ga as userSettingsQuery,
  za as viewOptionQuery,
  Ma as watchingHistoryQuery,
  ha as watchingProgressQuery,
  va as yangoBootstrapQuery,
  Pa as yangoCrossRedirectQuery,
  Ia as yangoTouchFilmPageQuery
};
